import * as React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Divider from 'material-ui/Divider';

import { InlineGridField, InlineGrid } from '@components/form';
import { tripsHistoriesColumns } from '@modules/trips/_tripsColumns';
import { TripsHistoriesDetailForm } from '@modules/trips/TripsHistoriesDetailForm';

const View: React.SFC<any> = _props => (
  <div>
    <Grid fluid={true}>
      <Row>
        <Col className="grid-system-margin" />
      </Row>
      <Row>
        <Col md={12}>
          <Row>
            <Col md={12}>
              <InlineGridField
                component={InlineGrid}
                name="histories"
                Form={TripsHistoriesDetailForm}
                columns={tripsHistoriesColumns}
                showCheckboxes={false}
                deleting={false}
                adding={false}
                filtering={false}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </Grid>
    <Divider />
  </div>
);
export const TripsHistoriesForm = View;



// WEBPACK FOOTER //
// ./src/modules/trips/TripsHistoriesForm.tsx